import { i18n } from '@vendor/libs/lang/lang';
const _ApiariesMineEditHandler = (function () {
    let isApplicationRequired = false;
    let initialData = {};
    const trackedData = [
        'geojson',
        'hives_count',
        'entity_id',
        'application_comments',
    ];
    const setInitialData = (data) => {
        initialData = data;
    };
    return {
        // Public functions
        init: function () {
            setTimeout(() => {
                $('form#edit_mine_apiary :input')
                    .on('change', function () {
                    const form = $(this).closest('form');
                    let changed = false;
                    for (const name of trackedData) {
                        if (initialData[name] !=
                            $(`form#edit_mine_apiary :input[name="${name}"]`).val()) {
                            changed = true;
                        }
                    }
                    if (changed) {
                        isApplicationRequired = true;
                        $('[data-app-apiary="application"]').show();
                        $('[data-app-apiary="no_application"]').hide();
                        form
                            .find('button[type="submit"]')
                            .text(i18n.trans('models/applications.pages.common.send'));
                    }
                    else {
                        isApplicationRequired = false;
                        $('[data-app-apiary="application"]').hide();
                        $('[data-app-apiary="no_application"]').show();
                        form
                            .find('button[type="submit"]')
                            .text(i18n.trans('common.save'));
                    }
                })
                    .trigger('change');
            }, 1000);
        },
        setInitialData,
    };
})();
window.ApiariesMineEditHandler = _ApiariesMineEditHandler;
